import type { SheetRootProps } from './Sheet.types'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import * as React from 'react'
import { Body } from './Body'
import { Content } from './Content'
import { Footer } from './Footer'
import { Close, Header } from './Header'
import { Trigger } from './Trigger'

function Root({ children, open, onClose, onOpenChange }: SheetRootProps) {
  const onOpenChangeHandler = (isOpen: boolean) => {
    if (onClose != null && !isOpen) {
      onClose()
    }
    if (onOpenChange) {
      onOpenChange(isOpen)
    }
  }

  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChangeHandler}>
      {children}
    </DialogPrimitive.Root>
  )
}

export const Sheet = {
  Root,
  Trigger,
  Body,
  Content,
  Footer,
  Header,
  Close,
}
